module.exports = __webpack_public_path__ + "img/footer-icon-youtube.f4b79666.png";